import React from "react";
import "./listloader.css";
import Global from "../../global";
const Listloader = (props)=>
{
  if (Global.Loader === "Ripple") {
    return (
      <section
        className="content"
        style={{ minHeight: "120px", paddingTop: "10px" }}
      >
        <div className="container-fluid">
          <div className="loaderInfinite">
            <div className="lds-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Hour Glass") {
    return (
      <section
        className="content"
        style={{ minHeight: "120px", paddingTop: "10px" }}
      >
        <div className="container-fluid">
          {/* <div className="lowloader"></div> */}
          <div className="loaderInfinite">
            <div className="lds-hourglass"></div>
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Grid Line") {
    return (
      <section
        className="content"
        style={{ minHeight: "120px", paddingTop: "10px" }}
      >
        <div className="container-fluid">
          <div className="loaderInfinite">
            <div className="lds-facebook">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Ellipsis") {
    return (
      <section
        className="content"
        style={{ minHeight: "120px", paddingTop: "10px" }}
      >
        <div className="container-fluid">
          <div className="loaderInfinite">
            <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
    );
  } else if (Global.Loader === "Grid") {
    return (
      <section
        className="content"
        style={{ minHeight: "120px", paddingTop: "10px" }}
      >
        <div className="container-fluid">
          <div className="loaderInfinite">
            <div className="lds-grid">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <section
        className="content"
        style={{ minHeight: "120px", paddingTop: "10px" }}
      >
        <div className="container-fluid">
          <div className="lowloader"></div>
        </div>
      </section>
    );
  }

}

export default Listloader;